export default {
	action: "Transférer la propriété",
	confirmTitle: "Transférer la propriété",
	confirmMessage:
		"{name} recevra une demande pour devenir Propriétaire ; s'il accepte, vous devenez Administrateur.",
	confirm: "Envoyer la demande",
	requested: "Demande envoyée ; en attente de la réponse de {name}.",
	pendingSent: "Transfert à {name} en attente de réponse jusqu'au {date}.",
	cancel: "Annuler la demande",
	canceled: "Demande annulée.",
	pageTitle: "Transfert de propriété",
	pendingReceived: "{name} souhaite vous transférer la propriété de {temple}.",
	explanation: "En acceptant, vous devenez le Propriétaire, et {name} reste Administrateur.",
	expiresAt: "La demande est valable jusqu'au {date}.",
	accept: "Accepter",
	decline: "Refuser",
	acceptedRelogin: "Transfert terminé : déconnectez-vous et reconnectez-vous pour utiliser l'accès Propriétaire.",
	accepted: "Vous êtes maintenant le Propriétaire du temple.",
	declined: "Demande refusée.",
	none: "Aucun transfert de propriété en attente.",
	banner: "Vous avez reçu une demande de transfert de la propriété du temple.",
	viewRequest: "Voir la demande",
	error: "Impossible de terminer ; veuillez réessayer.",
};
